<template>
  <div style="margin-top: 20px; margin-left: 20px">
    <el-button type="primary" @click="handleClick">点击初始化数据</el-button>
    <div class="v-modal loading" v-if="loading">
      加载中...
    </div>
  </div>
</template>

<script>
import { fetch } from '@/utils/api'
import { expire } from '@/utils/auth'
export default {
  data () {
    return {
      loading: false
      // post: null,
      // error: null
    }
  },
  watch: {
    '$route': 'fetchData'
  },
  mounted () {
    let result = expire()
    if (!result) {
      this.$router.push('/login')
    }
  },
  methods: {
    fetchData () {
      this.loading = true
      fetch({
        url: '/meterPayload/init'
      }).then(res => {
        console.info('initdata:', res)
        this.loading = false
        if (res) {
          this.$message({type: 'success', message: '初始化成功!'})
        } else {
          this.$message({type: 'error', message: '初始化失败!'})
        }
      })
    },
    handleClick () {
      this.fetchData()
    }
  }
}
</script>



// WEBPACK FOOTER //
// InitData.vue?9206b49e